'use client';

import { createContext, useContext } from 'react';

// Context rather than a prop: SignUpForm/FormWithLegals are also rendered from Server
// Components (e.g. TopSection.tsx). This is a workaround to avoid using a function prop
// on a Server Component.
const SignUpFormSuccessContext = createContext<(() => void) | null>(null);

export const SignUpFormSuccessProvider = SignUpFormSuccessContext.Provider;

export function useSignUpFormSuccess() {
  return useContext(SignUpFormSuccessContext);
}
